import axios from 'axios';
import * as yup from 'yup';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required(),
});
export async function newUserSetPassword({ newPassword, confirmNewPassword, email, hash, phone }) {
    const response = await axios.post('/api/profile/newUserSetPassword', {
        newPassword: newPassword,
        confirmNewPassword: confirmNewPassword,
        email: email,
        hash: hash,
        phone: phone
    });
    console.log(response);
    const { message } = await responseSchema.validate(response.data.data);
    console.log(message);
    return {
        message,
    };
}
